import { render, staticRenderFns } from "./AppRecommend.vue?vue&type=template&id=9a4f3c4e&scoped=true&"
import script from "./AppRecommend.vue?vue&type=script&lang=js&"
export * from "./AppRecommend.vue?vue&type=script&lang=js&"
import style0 from "./AppRecommend.vue?vue&type=style&index=0&id=9a4f3c4e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a4f3c4e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/hanzhu/nutstore-webpages/js_src_vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9a4f3c4e')) {
      api.createRecord('9a4f3c4e', component.options)
    } else {
      api.reload('9a4f3c4e', component.options)
    }
    module.hot.accept("./AppRecommend.vue?vue&type=template&id=9a4f3c4e&scoped=true&", function () {
      api.rerender('9a4f3c4e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/base/AppRecommend.vue"
export default component.exports